import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";
import type { ApiResponse } from "../types/api";

export interface Bank {
  name: string;
}

export type BankUpdateBody = Partial<Bank>;

interface BanksListResponse {
  data: Array<Bank & { _id: string; createdAt?: string }>;
}

export const banksApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllBanks: builder.query<ApiResponse<BanksListResponse>, void>({
      query: () => ({
        url: `${END_POINTS.banks}`,
        method: "GET",
      }),
    }),
    getBankById: builder.query<
      ApiResponse<Bank & { _id: string }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.banks}/${id}`,
        method: "GET",
      }),
    }),
    createBank: builder.mutation<
      ApiResponse<Bank & { _id: string }>,
      { data: Bank }
    >({
      query: (body) => ({
        url: END_POINTS.banks,
        method: "POST",
        body: body?.data,
      }),
    }),
    updateBank: builder.mutation<
      ApiResponse<Bank & { _id: string }>,
      { id: string; body: BankUpdateBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.banks}/${id}`,
        method: "PUT",
        body: body,
      }),
    }),
    deleteBank: builder.query<ApiResponse<{ _id: string }>, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.banks}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllBanksQuery,
  useLazyGetBankByIdQuery,
  useCreateBankMutation,
  useUpdateBankMutation,
  useLazyDeleteBankQuery,
} = banksApi;
